<template>
    <div class="fhv-centent">
        <h4 class="title-topic" v-text="h_msg.setting"></h4>
        <el-alert
            title="No USB storage device found! The current functionality is not available."
            type="warning"
            show-icon
            v-if="!isFountUsb">
        </el-alert>
        <el-form :model="ftpCFrom" :rules="fromCheck" 
            ref="ftpCFrom" 
            label-width="180px" 
            label-position="left"
            class="fhv-form" 
            size="mini"
            :disabled="$G_DEVICE_CFG.isReadOnly || !isFountUsb || isPost"
            v-loading="isPost">
            <el-form-item label="User Name:" prop="name">
                <el-input v-model="ftpCFrom.name"></el-input>
            </el-form-item>
            <el-form-item label="Password:" prop="password">
                <el-input v-model="ftpCFrom.password"></el-input>
            </el-form-item>
            <el-form-item label="Download URL:" prop="DURL">
                <el-input v-model="ftpCFrom.DURL">
                    <template slot="prepend">ftp://</template>
                </el-input>
            </el-form-item>
            <el-form-item label="Port:" prop="port">
                <el-input v-model.number="ftpCFrom.port"></el-input>
            </el-form-item>
            <el-form-item label="Device:" prop="deviceName">
                <el-select v-model="ftpCFrom.deviceName" placeholder="Please select" style="width: 100%">
                    <el-option v-for="item in deviceLists" :key="item.deviceName" :label="item.deviceName" :value="item.deviceName">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="Save Path:" prop="savePath">
                <el-input v-model="ftpCFrom.savePath"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="ftpDownload('ftpCFrom')" v-text="h_msg.btn_d"></el-button>
            </el-form-item>
        </el-form>
        <div class="ftpDownTable">
            <h4 class="title-topic" v-text="h_msg.records"></h4>
            <el-table :data="downloadRecords" border style="width: 100%" class="fhv-table">
                <el-table-column  prop="name" label="User Name" width="100">
                </el-table-column>
                <el-table-column prop="port"  label="Port" width="60">
                </el-table-column>
                <el-table-column prop="DURL" label="Download URL">
                </el-table-column>
                <el-table-column prop="savePath" label="Save Path" width="100">
                </el-table-column>
                <el-table-column  prop="progress" label="progress" width="90">
                </el-table-column>
                <el-table-column prop="status"  label="Status" width="100">
                </el-table-column>
                <el-table-column label="Action" width="100">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" 
                            :disabled="$G_DEVICE_CFG.isReadOnly"
                            @click.native.prevent="deleteDownloadRecords(scope.$index, downloadRecords)">Delete</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            h_msg:{
                setting:"FTP Client Setting",
                records:"Download records",
                btn_d:"Download"
            },
            ftpCFrom: {
                name: "",
                password: "",
                DURL: "",
                port: 21,
                deviceName: "",
                savePath: "xdown"
            },
            isFountUsb: false, // USB 挂载状态
            isPost: false,
            deviceLists: [],
            fromCheck: {
                name: [
                    { required: true, message: "Please enter the FTP user name.", trigger: "blur" },
                    { min: 1, max: 64, message: "The length is 1 to 64 characters.", trigger: "blur" }
                ],
                password: [
                    { required: true, message: "Please enter the FTP password.", trigger: "blur" },
                    { min: 1, max: 64, message: "The length is 1 to 64 characters.", trigger: "blur" }
                ],
                DURL: [{ required: true, message: "Please enter the URL.", trigger: "blur" }],
                port: [
                    { required: true, message: "Please enter the FTP port.", trigger: "blur" },
                    { type: "number", min: 0, max: 65535, message: "The port number must be 0~65535.",trigger: "blur"}
                ],
                deviceName: [
                    { required: true, message: "Please select a device.", trigger: "blur" }
                ],
                savePath: [
                    { required: true, message: "Please enter the savePath.", trigger: "blur" }
                ]
            },
            downloadRecords: []
        };
    },
    methods: {
        init: function () {
            this.getFtpClientData();
        },
        getFtpClientData: function(){ // 获取初始化信息
            let _this = this;
            let postData = {
                CmdType: "GET_FTP_C_D"
            };
            
            axios.post("/boafrm/fhFtpClient", postData)
                .then(function (response) {
                    let usbLists = response.data.usbLists;
                    if(usbLists!=undefined&&usbLists[usbLists.length - 1].length > 0)
                    {
                        usbLists.pop();
                        _this.deviceLists = usbLists;
                        _this.isFountUsb = true;
                        _this.ftpCFrom.deviceName = _this.deviceLists[0].deviceName;
                    }

                })
        },
        ftpDownload: function(formName) { //开始下载
            let _this = this;
            
            this.$refs[formName].validate(valid => {
                if (valid) {
                    let urls = _this.ftpCFrom.DURL.split("/");
                    let postData = {
                        CmdType: "SET_FTP_C_D",
                        name: _this.ftpCFrom.name,
                        password: _this.ftpCFrom.password,
                        DURL: "ftp://" + _this.ftpCFrom.DURL,
                        filename:urls[urls.length - 1],
                        serverIP:urls[0],
                        serverPath:_this.ftpCFrom.DURL.slice(urls[0].length + 1),
                        port: _this.ftpCFrom.port,
                        deviceName: _this.ftpCFrom.deviceName,
                        savePath: _this.ftpCFrom.savePath,
                        localPath: _this.ftpCFrom.deviceName + "/" + _this.ftpCFrom.savePath
                    };
                    _this.isPost = true;
                    axios.post("/boafrm/fhFtpClient", postData)
                        .then(function (response) {
                            _this.isPost = false;
                            let retFtpd = {
                                name: postData.name,
                                DURL: postData.DURL,
                                port: postData.port,
                                deviceName: postData.deviceName,
                                savePath: postData.savePath,
                                progress: response.data.dStatus ? "100%" : "0%",
                                status:response.data.dStatus ? "Complete" : "Faild"
                            }
                            _this.downloadRecords.push(retFtpd);
                            if(response.data.dStatus)
                            {
                                _this.$message({
                                    message: 'Download success!',
                                    type: 'success'
                                });
                            }
                            else
                            {
                                _this.$message.error('Error! ' + response.data.errorMsg);
                            }
                            
                        })
                } else {
                    return false;
                }
            });
        },
        deleteDownloadRecords:function(index, rows) {
            rows.splice(index, 1);
        }
    },
    beforeMount() {
        this.init();
    }
}
</script>
